<template>
	<teleport to="body">
		<div class="relative z-40" aria-labelledby="modal-title" role="dialog" aria-modal="true">
			<div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
			<div class="fixed inset-0 z-10 w-full h-screen overflow-y-auto" @click="$emit('abort')">
				<div class="flex min-h-full justify-center text-center items-center xs:p-1">
					<div class="relative transform rounded-sm bg-white text-left shadow-xl transition-all w-full lg:w-3/4 xl:w-1/4" @click.stop>
						<div class="bg-gray-50 px-4 py-3">
							<h3 class="text-base font-semibold leading-6 text-gray-900">Información de facturación</h3>
						</div>
						<form @submit.prevent="submit" novalidate class="px-4 py-3 flex flex-col gap-2">
							<div>
								<label class="block text-sm font-medium text-gray-700">DNI/CIF</label>
								<input v-model="form.billDocument" type="text" required class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" :class="{ 'border-red-600': !!getErrorMessage('billDocument') }" />
								<p class="text-red-600">
									<small>{{ getErrorMessage('billDocument') }}</small>
								</p>
							</div>
							<div>
								<label class="block text-sm font-medium text-gray-700">IBAN</label>
								<input v-model="form.billIban" type="text" required class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" :class="{ 'border-red-600': !!getErrorMessage('billIban') }" />
								<p class="text-red-600">
									<small>{{ getErrorMessage('billIban') }}</small>
								</p>
							</div>
							<div>
								<label class="block text-sm font-medium text-gray-700">Dirección</label>
								<input v-model="form.billAddress" type="text" required class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" :class="{ 'border-red-600': !!getErrorMessage('billAddress') }" />
								<p class="text-red-600">
									<small>{{ getErrorMessage('billAddress') }}</small>
								</p>
							</div>
							<div>
								<label class="block text-sm font-medium text-gray-700">Ciudad</label>
								<input v-model="form.billCity" type="text" required class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" :class="{ 'border-red-600': !!getErrorMessage('billCity') }" />
								<p class="text-red-600">
									<small>{{ getErrorMessage('billCity') }}</small>
								</p>
							</div>
							<div>
								<label class="block text-sm font-medium text-gray-700">Código postal</label>
								<input v-model="form.billZipcode" type="text" required class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" :class="{ 'border-red-600': !!getErrorMessage('billZipcode') }" />
								<p class="text-red-600">
									<small>{{ getErrorMessage('billZipcode') }}</small>
								</p>
							</div>
							<div class="mt-4 w-full flex justify-between">
								<Button type="button" color="tertiary" @click="$emit('abort')">
									<icon name="ri-close-line" class="mr-1" />
									Cancelar
								</Button>
								<Button type="submit" :loading="loading" loadingLabel="Guardando...">
									<icon name="ri-save-2-line" class="mr-1" />
									Guardar
								</Button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</teleport>
</template>

<script setup lang="ts">
import { ValidationError } from '@/errors/ValidationError'
import { user } from '@/user'
import { ref } from 'vue'
import Button from '../../components/Button.vue'
import { put } from '../../services/api'
import { useValidationErrorsMessages } from '../../utils/useValidationErrorsMessages'

const emit = defineEmits(['abort', 'success'])
const loading = ref(false)

const form = ref({
	billDocument: user.value.billDocument || '',
	billAddress: user.value.billAddress || '',
	billCity: user.value.billCity || '',
	billZipcode: user.value.billZipcode || '',
	billIban: user.value.billIban || ''
})

const error = ref<ValidationError>(<any>{})

const getErrorMessage = useValidationErrorsMessages(error)

const submit = async () => {
	loading.value = true
	try {
		const { data } = await put({ name: 'me.user.bill' }, form.value)
		if (data.config) {
			const newConfig = { ...user.value.config, ...data.config }
			user.value.config = newConfig
			localStorage.setItem('user', JSON.stringify({ ...user.value, config: newConfig }))
			emit('success')
		}
	} catch (err) {
		error.value = err
	}
	loading.value = false
}
</script>
